export default {
    message: {
        tiers: {
            t1: {
                label: "Bağımsız",
                desc: "<p>Tüm sanal, web ve SaaS uygulamalarına birleşik erişim, kullanıcıları, uygulamaları ve verileri uçtan uca bağlamsal güvenlik kontrolleriyle korur.</p><p>Web, SaaS, sanal ve mobil uygulamalar için VPN’siz proxy ve tek oturum açma (SSO) imkanı sunar ve kötü amaçlı içerik, keylogger’lar ve ekran görüntüsü alan kötü amaçlı yazılımlara karşı koruma sağlar.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Granüler güvenlikle tam bir dijital çalışma alanına ihtiyaç duyan, ancak sanal uygulamalar ve masaüstleri gerektirmeyen çalışanlar için eksiksiz çalışma alanı çözümü.</p><p>Workspace Standard özelliklerinin yanı sıra SaaS ve web için gelişmiş güvenlik kontrolleri, bütünleştirilmiş uç nokta yönetimi ve Content Collaboration Premium içerir.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops için karma dağıtım seçenekleri içeren kapsamlı çalışma alanı çözümü.</p><p>Workspace Premium özelliklerinin yanı sıra Citrix Virtual Apps and Desktops için bir bulut yönetimi seçeneğini içerir.</p>"
            }
        }
    }
}